import { GET_GALLERY_CONTENT_BY_ID_REQUEST } from './GalleryActionTypes';

export default [GET_GALLERY_CONTENT_BY_ID_REQUEST];
